import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildScaleSpendChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelScaleSpend = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Scale Spend";
  const lines = stripTitleLines(cleanLines(markdown));
  const { table, before, after } = extractTableBlock(lines);
  const renamedTable =
    table && Array.isArray(table.rows)
      ? {
          ...table,
          rows: table.rows.map((row) => {
            if (!row || row.length === 0) return row;
            const [metric, ...rest] = row;
            const text = String(metric || "");
            let renamed = text;
            if (text === "Contribution Margin 1 (CM1)") {
              renamed = "Contribution Before Marketing";
            } else if (text === "Current CM2") {
              renamed = "Contribution After Marketing";
            } else if (text === "CM2 at +20% CAC") {
              renamed = "Contribution After Marketing at +20% CAC";
            } else if (text === "CM2 at +50% CAC") {
              renamed = "Contribution After Marketing at +50% CAC";
            }
            if (text.includes("Profit Per Order Before Ad Spend")) {
              renamed = "Contribution Before Marketing";
            } else if (text.includes("Profit Per Order After Ad Spend")) {
              renamed = "Contribution After Marketing";
            } else if (text.includes("Profit Per Order At 20% Higher Spend")) {
              renamed = "Contribution After Marketing (20% Higher Spend)";
            } else if (text.includes("Profit Per Order At 50% Higher Spend")) {
              renamed = "Contribution After Marketing (50% Higher Spend)";
            }
            return [renamed, ...rest];
          }),
        }
      : table;
  const chart = buildScaleSpendChart(renamedTable);
  const { tail } = splitByHeading(after, "What Does This Mean?");
  const preBullets = toBullets(before);
  const preParagraphs = preBullets.length ? [] : toParagraphs(before);
  const bullets = toBullets(tail);
  let paragraphs = toParagraphs(tail.length ? tail : lines);
  const verdict = extractVerdict(paragraphs);
  if (verdict) paragraphs = paragraphs.slice(0, -1);

  const sections = [];
  if (preBullets.length || preParagraphs.length) {
    sections.push({
      title: "Signal Summary",
      bullets: preBullets,
      paragraphs: preParagraphs,
    });
  }
  sections.push({
    title: "Scale Spend Table",
    chart,
    chartTitle: "Stress Test Curve",
    chartSubtitle:
      "This chart makes the drop from current contribution to higher CAC scenarios hit harder.",
    table: renamedTable,
    paragraphs: [],
  });
  sections.push({
    title: "What Does This Mean?",
    bullets,
    paragraphs,
    verdict,
  });

  return (
    <FunnelInsightCard
      title={title}
      kicker="Scaling Outlook"
      sections={sections}
    />
  );
};

export default FunnelScaleSpend;
